// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable no-console */
import { isProduction } from './isProduction';

export const logFormData = <Data extends Record<string, unknown>>(
  label: string,
  data: Data,
  mapper?: (key: string, value?: ValuesOf<Data>) => unknown,
) => {
  const isProductionValue = isProduction();

  if (!isProductionValue) {
    const dataMapper = mapper || ((key: string, value?: ValuesOf<Data>) => ({ key, value }));

    console.groupCollapsed(label);
    console.table(Object.entries(data).map(([key, value]) => dataMapper(key, value as ValuesOf<Data>)));
    console.groupEnd();
  }
};
